// function insertDemoBlocks() {
//   const container = document.querySelector('.items-grid');
//   const items = Array.from(container.querySelectorAll('.areas-item'));
//   const isMobile = window.innerWidth <= 768; // adjust based on your breakpoint
//   const chunkSize = isMobile ? 2 : 3;

//   // Clear existing demo blocks if re-running
//   container.querySelectorAll('.demo-areas-content-block').forEach(el => el.remove());

//   items.forEach((item, index) => {
//     // Since we insert AFTER the item, offset by +1
//     const isLastInGroup = (index + 1) % chunkSize === 0;

//     if (isLastInGroup) {
//       const demoBlock = document.createElement('div');
//       demoBlock.className = 'demo-areas-content-block';
//       container.insertBefore(demoBlock, items[index + 1]);
//     }
//   });
// }

// function insertDemoBlocks() {
//   const isMobile = window.innerWidth <= 768;
//   const chunkSize = isMobile ? 2 : 3;

//   // Loop through all .items-grid containers
//   document.querySelectorAll('.items-grid').forEach(container => {
//     // Remove previously inserted demo blocks
//     container.querySelectorAll('.demo-areas-content-block').forEach(el => el.remove());

//     // Get a fresh static list of areas-items (won't change even if we insert DOM nodes)
//     const items = Array.from(container.querySelectorAll('.areas-item'));

//     items.forEach((item, index) => {
//       // After every chunkSize items, insert a demo block
//       const isLastInGroup = (index + 1) % chunkSize === 0;
//       if (isLastInGroup) {
//         const demoBlock = document.createElement('div');
//         demoBlock.className = 'demo-areas-content-block';

//         // Safely insert after current item
//         const nextSibling = item.nextElementSibling;
//         if (nextSibling) {
//           container.insertBefore(demoBlock, nextSibling);
//         } else {
//           container.appendChild(demoBlock);
//         }
//       }
//     });
    
//   });
// }
function insertDemoBlocks() {
  const isMobile = window.innerWidth <= 768;
  const chunkSize = isMobile ? 2 : 3;

  document.querySelectorAll('.items-grid').forEach(container => {
    // Remove previously inserted demo blocks
    container.querySelectorAll('.demo-areas-content-block').forEach(el => el.remove());

    const items = Array.from(container.querySelectorAll('.areas-item'));
    const lastIndex = items.length - 1;

    items.forEach((item, index) => {
      const isLastInGroup = (index + 1) % chunkSize === 0;
      const isLastItem = index === lastIndex;

      if (isLastInGroup || isLastItem) {
        const demoBlock = document.createElement('div');
        demoBlock.className = 'demo-areas-content-block';

        const nextSibling = item.nextElementSibling;
        if (nextSibling) {
          container.insertBefore(demoBlock, nextSibling);
        } else {
          container.appendChild(demoBlock);
        }
      }
    });
  });
}

// const boxes = document.querySelectorAll('.areas-item');
document.querySelectorAll('.areas-item').forEach((box, index) => {
  box.addEventListener("click", (e) =>{
    const currentBox = e.currentTarget;
    currentBox.closest('.items-grid').querySelectorAll('.areas-item').forEach(item => {
      if(item != currentBox){
        item.classList.remove("active-box");
      }
    });
    currentBox.classList.toggle("active-box")
    const content = currentBox.querySelector(".accordion-main-container");

    if(currentBox.classList.contains("active-box")){
      const clonedContent = content.cloneNode(true);
      let targetContainer = currentBox.nextElementSibling;
      while (targetContainer) {
        if(targetContainer.classList.contains('demo-areas-content-block')){
          break;
        }
        targetContainer = targetContainer.nextElementSibling;
      }

      let detailsElement = document.createElement('div')
      detailsElement.className = 'selected-details';
      clonedContent.appendChild(detailsElement)
      
      if (targetContainer) {
        // next.innerHTML = "";
        // next.appendChild(clonedContent);
        currentBox.closest('.items-grid').querySelectorAll('.demo-areas-content-block').forEach(item => item.classList.remove("isShown"));
        targetContainer.innerHTML = ""; 
        clonedContent.classList.add("flexadd");
        
        targetContainer.appendChild(clonedContent);
        targetContainer.classList.add("isShown");
        clonedContent.querySelectorAll('.container-boxes').forEach(containerBox => {
          containerBox.addEventListener("click", (e) => {
            const currentItem = e.currentTarget;
            currentItem.closest('.accordion-main-container.flexadd').querySelectorAll('.container-boxes').forEach(item => {
              if(item != currentItem){
                item.classList.remove("isDisplayed")
              }
            })
            
            currentItem.classList.toggle("isDisplayed")
            let targetElement = currentItem.closest('.accordion-main-container.flexadd').querySelector(".selected-details");
            if(currentItem.classList.contains("isDisplayed")){
              const content = currentItem.querySelector(".accordion-boxes").cloneNode(true);
              targetElement.innerHTML = ''
              targetElement.appendChild(content);
              targetElement.classList.add("conentVisible")
              // setTimeout(() => {
              //   targetElement.scrollIntoView({behaviour: 'smooth', block: 'nearest'});
              // }, 0)
            }else{
              currentItem.classList.remove("isDisplayed")
              targetElement.classList.remove("conentVisible")
              targetElement.innerHTML = ''
            }
          })
        })
      }
      
      // const targetContainer = currentBox.closest('.items-grid').querySelector('.demo-areas-content-block');
      // if (!targetContainer) return;
      
      // targetContainer.innerHTML = ""; 
      // clonedContent.classList.add("flexadd");
      
      // targetContainer.appendChild(clonedContent);
      // targetContainer.classList.add("isShown");
    }else{
      currentBox.classList.remove("active-box")
      currentBox.closest('.items-grid').querySelectorAll('.demo-areas-content-block').forEach(item => {
        item.classList.remove("isShown")
        item.innerHTML = '';
      })
    }
  })
})

// document.querySelectorAll('.container-boxes').forEach(containerBox => {
//   containerBox.addEventListener("click", (e) => {
//     const currentItem = e.currentTarget;
//     const content  = 
//     currentItem.closest('.accordion-main-container.flexadd').querySelectorAll('.container-boxes').forEach(item => {
//       if(item != currentItem){
//         item.classList.remove("isDisplayed")
//       }
//     })
    
//     currentItem.classList.toggle("isDisplayed")
//     let targetElement = currentItem.closest('.accordion-main-container.flexadd').querySelector(".selected-details");
//     if(currentBox.classList.contains("active-box")){
//       const content = currentItem.querySelector(".accordion-boxes").cloneNode(true);
//       targetElement.innerHTML = ''
//       targetElement.appendChild(content);
//       targetElement.classList.add("conentVisible")
      
//     }else{
//       currentItem.classList.remove("isDisplayed")
//       targetElement.classList.remove("conentVisible")
//       targetElement.innerHTML = ''
//     }
//   })
// })
window.addEventListener('load', insertDemoBlocks);

window.addEventListener('resize', () => {
  insertDemoBlocks();
});